import {
  Lightbulb, Users, PiggyBank, Sparkles,
  HandHeart, Puzzle, Mic, Trophy,
} from "lucide-react";

const SKILLS = [
  { icon: Lightbulb,  label: "Entrepreneurship",  desc: "Spot real problems, design real businesses.", tint: "yellow" },
  { icon: Trophy,     label: "Leadership",         desc: "Lead a team using your unique strengths.",     tint: "green"  },
  { icon: PiggyBank,  label: "Financial Literacy", desc: "Track money. Price right. Reinvest smart.",    tint: "yellow" },
  { icon: Sparkles,   label: "AI Literacy",        desc: "Use AI as a coach, not a shortcut.",           tint: "green"  },
  { icon: Users,      label: "Teamwork",            desc: "Build with people who think differently.",     tint: "yellow" },
  { icon: Puzzle,     label: "Problem Solving",    desc: "Break big challenges into tiny wins.",         tint: "green"  },
  { icon: Mic,        label: "Communication",      desc: "Tell your story with confidence.",             tint: "yellow" },
  { icon: HandHeart,  label: "Pitch Skills",       desc: "Win a room in 60 seconds.",                    tint: "green"  },
];

const TINT = {
  yellow: { bg: "bg-[#FFFBEB]", icon: "bg-[#FFD500] text-black",   ring: "ring-[#FFD500]/30" },
  green:  { bg: "bg-[#F0FDF4]", icon: "bg-[#00E65C] text-black",   ring: "ring-[#00E65C]/30" },
};

/**
 * WhatIsThisSection — "More Than Lemonade" — bento-style 8-card grid
 * showing what students actually build/learn. Alternating yellow/green tints.
 */
export default function WhatIsThisSection() {
  return (
    <section
      id="program"
      className="relative bg-white py-20 sm:py-28"
      data-testid="what-is-this-section"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="max-w-3xl mb-12 sm:mb-16">
          <p className="text-xs font-black tracking-[0.22em] uppercase text-gray-500 mb-3">
            The Program
          </p>
          <h2 className="text-[32px] md:text-5xl font-black tracking-tighter leading-[1.05] text-black">
            More Than <span className="lsbp-yellow-chip">Lemonade.</span>
          </h2>
          <p className="mt-5 text-base md:text-xl text-gray-700 leading-relaxed max-w-2xl">
            The Lemonade Stand Business Plan helps students think like
            entrepreneurs, collaborate like teams, and build confidence through
            interactive lessons, AI guidance, and real-world business concepts.
          </p>
        </div>

        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5"
          data-testid="what-is-this-grid"
        >
          {SKILLS.map((s, idx) => {
            const tint = TINT[s.tint];
            return (
              <article
                key={s.label}
                className={`relative ${tint.bg} ring-1 ${tint.ring} rounded-3xl p-5 sm:p-6 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(255,213,0,0.18)]`}
                data-testid={`skill-card-${idx}`}
              >
                <div className={`${tint.icon} w-11 h-11 rounded-2xl flex items-center justify-center mb-4 shadow-sm`}>
                  <s.icon className="w-5 h-5" />
                </div>
                <h3 className="text-2xl font-extrabold text-black tracking-tight mb-1">
                  {s.label}
                </h3>
                <p className="text-base text-gray-700 leading-snug">
                  {s.desc}
                </p>
              </article>
            );
          })}
        </div>

      </div>
    </section>
  );
}
